import React from "react";
import styled from "styled-components";
import { Map, Phone, Email, FacebookRounded } from "@mui/icons-material";
import { COMPANY_LOCATION, PHONE_NUMBER, EMAIL } from "../constants/menu";
import { COLOR_BLACK, COLOR_FOOTER, COLOR_WHITE } from "../constants/colors";
import { NavLink } from "react-router-dom";

const Wrapper = styled.div`
  color: white;
  background-color: ${COLOR_FOOTER};
  padding: 24px;
  display: block;
  font-size: 16px;
  line-height: 1.4;
  color: ${COLOR_WHITE};
  background-color: ${COLOR_FOOTER};
  width: 100%;
  box-sizing: border-box;
  z-index: 98;

  .inner {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px;
    text-align: center;
    margin: 0 auto;
    position: relative;
    width: 90%;
    max-width: 1200px;
  }

  .icon {
    position: relative;
    top: 2px;
    right: 3px;
    font-family: "Material Icons";
    font-size: 16px;
  }
`;

const Item = styled.a`
  color: ${COLOR_WHITE};
  cursor: pointer;
  text-decoration: none;
  font-weight: 400;
  background-color: transparent;
  font-weight: 400;

  &:hover {
    text-decoration: underline;
    color: ${COLOR_BLACK};
  }
`;

const ItemLink = styled(NavLink)`
  color: ${COLOR_WHITE};
  cursor: pointer;
  text-decoration: none;
  font-weight: 400;
  background-color: transparent;
  font-weight: 400;

  &:hover {
    text-decoration: underline;
    color: ${COLOR_BLACK};
  }
`;

const Contact = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .contact {
    margin: 14px 0 0 0;
    text-decoration: underline;
  }
`;

const Legal = styled.div`
  display: flex;
`;

const Footer = () => {
  return (
    <Wrapper>
      <div className="inner">
        <Item href="https://www.immonline.fr/honoraires">Honoraires</Item>
        <Item href="https://www.immonline.fr/qui-sommes-nous">
          Qui sommes nous?
        </Item>
        <ItemLink to={"/espace-presse"}>Espace presse</ItemLink>
        <Contact>
          <div className="contact">Contact :</div>
          <Item target="_blank" href={COMPANY_LOCATION}>
            <Map className="icon" />
            64, Rue Ampère 75017 Paris
          </Item>
          <Item href={PHONE_NUMBER}>
            <Phone className="icon" />
            0173790910
          </Item>
          <Item href={EMAIL}>
            <Email className="icon" />
            gestion@immonline.fr
          </Item>
        </Contact>
        <br />
        <Item href="https://www.facebook.com/CabinetImmoOnline/">
          <FacebookRounded className="icon" />
          Facebook
        </Item>
        <br />
        <Legal>
          <Item href="https://www.immonline.fr/mentions">Mentions légales</Item>
          <span> - © immonline.fr 2022</span>
        </Legal>
      </div>
    </Wrapper>
  );
};

export default Footer;
